module.exports = __webpack_public_path__ + "img/5.d274cae9.png";